<div class="flex flex-wrap">
  @for (attribute of items; track trackByItem($index, attribute); let isFirst = $first) {
    <div class="w-12 flex"
      [class.m-t-2]="!isFirst">
      <div class="s2 w-3-x w-3-m w-3-s"
      sizeClass="L:attribute-label">{{ attribute.label }}:&nbsp;</div>
      <div class="p2 col-11 w-9">{{ attribute.valuesLabels.join(', ') }}</div>
    </div>
  }
</div>